import { I18n } from '@front/volcanion'

import _ from 'lodash'

import { ShortIncident } from '@abra/panels/Incident'

class Callbacks {
  static openLocalNotificationHandler(openNotification) {
    return function openLocalNotification(event_id) {
      openNotification(ShortIncident, {
        persist: true,
        anchor: 'top-right',
        id: event_id,
        props: { event_id }
      })
    }
  }

  static openDesktopNotificationHandler(searchIncident, notifications, closeNotification) {
    return async function openDesktopNotification(event_id) {
      const [incident] = await searchIncident({ event_id })

      const notification = new Notification(_.join(['🔔', I18n.t('incident.alert')], ' '), {
        body: I18n.t(`incident.${incident?.name}`, { count: 1 }),
        tag: event_id,
        silent: true,
        requireInteraction: true
      })

      notification.onclick = () => {
        window.open(`/incident?event_id=${event_id}`, '_blank')
        notification.close()
        delete notifications.current[event_id]
        closeNotification(event_id)
      }

      notifications.current[event_id] = notification
    }
  }

  static closeDesktopNotificationHandler(notifications) {
    return function closeDesktopNotification(event_id) {
      notifications.current[event_id]?.close()
      delete notifications.current[event_id]
    }
  }

  static playAudioHandler(notif_path) {
    return async function playAudio() {
      try {
        await new Audio(notif_path).play()
      } catch (err) {
        console.warn('Notification sound autoplay blocked by the browser', err)
      }
    }
  }
}

export default Callbacks
